
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { useEffect, useRef, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import styles from './App.module.scss';
import Authenticate from './Components/Authenticate/Authenticate';
import Downloader from './Components/Downloader/Downloader';
import Footer from './Components/Footer/Footer';
import { ai, getAppInsights } from './Utils/AppInsights';
import { Logger } from './Utils/Logger';
import { getUrlParameter } from './Utils/UrlUtils';
import { Environments, IEnvironment } from './config/Environments';
import AppContextProvider from './contexts/AppContext';


function App() {
  let environment = useRef<IEnvironment | undefined>();

  let isInDebugMode = useRef<boolean>(false);
  let logger = useRef<Logger | undefined>();
  let appInsights = useRef<ApplicationInsights | undefined>();
  let downloadItemGuid = useRef<string | undefined>();

  const [initialized, setInitialized] = useState<boolean>(false);
  let correlationId = useRef<string>('');




  useEffect(() => {

    console.debug("AppRoot constructor called...");

    const urlParams = new URLSearchParams(document.location.search);

    //-------------  ENVIRONMENT  -------------------------------------------------------------
    const defaultEnvironment = document.location.href.includes("dhi-downloads-ui.azurewebsites.net") || document.location.href.includes("download.dhigroup.com") ?
      'live' :
      document.location.href.includes("dhi-downloads-ui-test") ? 'test' : 'dev';
    console.log(`According your url it seems your are in the '${defaultEnvironment}' environment.`);

    const env = getUrlParameter(urlParams, "env", false, "Environment", defaultEnvironment);//|| 'dev'; //dev|live
    if (env !== defaultEnvironment)
      console.log(`Anyway, environment directly specified by the url 'env' parameter is '${env}', so this will be used.`);

    const envir = env ? Environments[env] : undefined;
    if (!envir) {
      throw Error(`No environment is defined for sent environment id '${env}'. Use one of these dev|test|prod|local (note, that local will work only, if you run the web api locally at specific address - just for developers with the code!!)`)
    }
    environment.current = envir;


    //-------------  IS DEBUG  ------------------------------------------------------------------
    const inDebug = getUrlParameter(urlParams, "debug", false, "Debug mode", 'false');
    isInDebugMode.current = inDebug ? inDebug.toUpperCase() === "TRUE" : false;

    //------------    CORRELATION ID --------------------------------------------------

    correlationId.current = getUrlParameter(urlParams, "corid", false, "Correlation id", uuidv4())!;
    console.debug('========================================================================');
    console.debug('CORRELATION-ID: ' + correlationId.current);
    console.debug('========================================================================');

    //-------------  download details  -------------------------------------------------------------
    downloadItemGuid.current = getUrlParameter(urlParams, "guid", true, "Item GUID", undefined);


    //-------------  Application insights  -------------------------------------------------------------
    console.debug('Initializing App Insights...');
    ai.initialize(environment.current!);
    appInsights.current = getAppInsights();

    //-------------  Logger  -------------------------------------------------------------
    console.debug('Initializing logger...');
    logger.current = new Logger(appInsights.current!, '', isInDebugMode.current!);


    setInitialized(true);
  }, [])



  return (

    <div className={styles.App}>
      {initialized &&
        <AppInsightsErrorBoundary onError={() => <h1>Something went wrong, check the App insights</h1>} appInsights={ai.reactPlugin} >

          <AppContextProvider
            isInDebugMode={isInDebugMode.current!}
            environment={environment.current!}
            correlationId={correlationId.current!}
            appInsights={appInsights.current!}
            logger={logger.current!}
          >

            <BrowserRouter>

              <Routes>
                <Route path="/" element={<div className={styles.label}>Please go to our <a href='https://support.dhigroup.com/download'>download center</a> to select a file to download</div>}>

                </Route>
                <Route path="/protected" element={
                  <Authenticate />
                } />
                <Route path="/authenticated" element={
                  <Downloader authenticationRequired={true} itemGuid={downloadItemGuid.current!} />
                } />
                <Route path="/open" element={
                  <Downloader authenticationRequired={false} itemGuid={downloadItemGuid.current!} />
                } />

              </Routes>
            </BrowserRouter>
            <Footer />

          </AppContextProvider>
        </AppInsightsErrorBoundary >}
      {!initialized && <div>Initializing app...</div>}
    </div>

  );
}

export default App;
